// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { DELETE_ASSETS } from "../../graphql/mutations/assets/assets.mutations";

const useDeleteManyAssets = () => {
  const [deleteAssetsMutation, { loading, error, data }] =
    useMutation(DELETE_ASSETS);

  const deleteManyAssets = async (assets) => {
    try {
      await deleteAssetsMutation(assets);
      return data.deleteAssets;
    } catch (error) {
      console.error(`Error deleting assets: ${error?.message}`);
      alert(`Error deleting assets: ${error?.message}`);
    }
  };

  return { deleteManyAssets, loading, error };
};

export default useDeleteManyAssets;
